import ActionType from '@actions/type';
import { parseUrl } from '@helpers/router';

function parseParam(param) {
  if (!param) return {};
  if ({}.hasOwnProperty.call(param, 'innId')) {
    return {
      ...param,
      innId: parseInt(param.innId, 10),
    };
  }
  return param;
}

export default function router(state = parseUrl(document.location.href), action) {
  switch (action.type) {
    case ActionType.JUMP_TO:
      return {
        prevRouter: action.prevRouter,
        path: action.router.path,
        param: parseParam(action.router.param),
        t: action.router.t || state.t || 0,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/app/router.js